'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { useKarte } from '@/hooks/useKarte'

/**
 * KARTEページビュートラッキングコンポーネント
 * ルート変更時に自動でページビューを送信する
 */
export default function PageView() {
  const pathname = usePathname()
  const { trackPageView } = useKarte()

  useEffect(() => {
    // ページ遷移時にページビューを送信
    const timer = setTimeout(() => {
      trackPageView()
    }, 100) // 少し遅延させてDOMが確実に更新されるようにする

    return () => clearTimeout(timer)
  }, [pathname, trackPageView])

  return null // レンダリング不要
}
